import React, { useState, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, MenuItem, Select, useMediaQuery, Typography, Grid, Stack, Checkbox, FormControlLabel, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ButtonView } from '../../../components/Button';
import { InputLabel } from '../../../../home/Home-components';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));
export interface DialogTitleProps2 {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps2) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export const AddPriceTable = (props: any) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [showAddOn, setShowAddOn] = useState(false);
    const [noOfSamples, setNoOfSamples] = useState('1');
    const [selectedSuite, setSelectedSuite] = useState('');

    const handleTableName = (ev: any) => {
        props.setIdSelected(ev.target.value);
    }

    const handleAddOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (props.enableAddOnCheckbox) {
            setShowAddOn(event.target.checked);
        }
    }

    const handleNoOfSamplesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        // Allow only numbers
        if (value === '' || /^[0-9]+$/.test(value)) {
            setNoOfSamples(value);
        }
    }

    const handleSuiteChange = (event: any) => {
        setSelectedSuite(event.target.value);
    }

    // Reset Add-On checkbox when it becomes disabled
    useEffect(() => {
        if (!props.enableAddOnCheckbox && showAddOn) {
            setShowAddOn(false);
        }
    }, [props.enableAddOnCheckbox]);

    // Reset all form states when dialog closes
    useEffect(() => {
        if (!props.open) {
            setShowAddOn(false);
            setSelectedSuite('');
            setNoOfSamples('1');
        }
    }, [props.open]);

    return (
        <div>
            <BootstrapDialog
                onClose={props.onClose}
                aria-labelledby={props.labelledby}
                open={props.open}
                fullScreen={fullScreen}
                fullWidth={true}
                sx={{ padding: 10 }}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={props.onClose}>
                    Add to Price Table Dialog
                </BootstrapDialogTitle>
                <DialogContent dividers style={{ padding: 40 }}>
                    <Grid container spacing={3} style={{ paddingTop: 20 }}>
                        <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                            <InputLabel>
                                <Typography variant="body1" gutterBottom>
                                    Table Name
                                </Typography>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                            <Stack spacing={2} sx={{ width: '30ch', paddingLeft: 1 }}>
                                <Select
                                    labelId="demo-select-small"
                                    id="demo-select-small"
                                    label=""
                                    size='small'
                                    onChange={handleTableName}
                                >
                                    {props && props.priceTables.map((item: any, index: any) => (
                                        <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                    ))}
                                </Select>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} style={{ paddingTop: 40 }}>
                        <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                            <InputLabel>
                                <Typography variant="body1" gutterBottom>
                                    No of Samples
                                </Typography>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                            <Stack spacing={2} sx={{ width: '30ch', paddingLeft: 1 }}>
                                <TextField
                                    size='small'
                                    value={noOfSamples}
                                    onChange={handleNoOfSamplesChange}
                                    placeholder="Enter number of samples"
                                    type="text"
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9]*'
                                    }}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    
                    <Grid container spacing={3} style={{ paddingTop: 30 }}>
                        <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}/>
                        <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0, paddingLeft: 32 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                        checked={showAddOn}
                                        onChange={handleAddOnChange}
                                        name="addOn"
                                        disabled={!props.enableAddOnCheckbox}
                                    />
                                }
                                label="Addon Test"
                            />
                        </Grid>
                    </Grid>

                    {showAddOn && (
                        <Grid container spacing={3} style={{ paddingTop: 30 }}>
                            <Grid item xs={2} sm={3} md={3} style={{ paddingTop: 0 }}>
                                <InputLabel>
                                    <Typography variant="body1" gutterBottom>
                                        Select Suite
                                    </Typography>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={10} sm={9} md={9} style={{ paddingTop: 0 }}>
                                <Stack spacing={2} sx={{ width: '30ch', paddingLeft: 1 }}>
                                    <Select
                                        labelId="addon-select"
                                        id="addon-select"
                                        label=""
                                        size='small'
                                        value={selectedSuite}
                                        onChange={handleSuiteChange}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    width: 'auto',
                                                    minWidth: '30ch',
                                                    maxWidth: '50ch'
                                                },
                                            },
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }
                                        }}
                                        sx={{
                                            '& .MuiSelect-select': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }
                                        }}
                                    >
                                        {(!props?.selectedSuiteList || props?.selectedSuiteList?.length === 0) && (
                                            <MenuItem value="">No Option</MenuItem>
                                        )}
                                        {props?.selectedSuiteList && props?.selectedSuiteList?.map((suite: any, index: any) => (
                                            <MenuItem 
                                                key={index} 
                                                value={suite?.item2}
                                                sx={{
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '50ch',
                                                    '&:hover': {
                                                        overflow: 'visible',
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word'
                                                    }
                                                }}
                                                title={suite?.item1}
                                            >
                                                {suite?.item1}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Stack>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions>
                    <ButtonView
                        variant="contained"
                        name='Add To Result Table'
                        type='submit'
                        color="primary"
                        startIcon={<AddCircleOutlineOutlinedIcon />}
                        disabled={(showAddOn && !selectedSuite)}
                        onClick={() => props.submitPriceTable(noOfSamples, selectedSuite)}
                    />
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
